/**
 * @generated SignedSource<<ec77db4034e61aa868fd80937f1d68ca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfilePreviewRelay_user$data = {
  readonly accountId: string;
  readonly email?: string | null | undefined;
  readonly extendedProfile?: {
    readonly department: string | null | undefined;
    readonly jobTitle: string | null | undefined;
    readonly location: string | null | undefined;
    readonly organization: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly picture: AGG$URL;
  readonly " $fragmentType": "UserProfilePreviewRelay_user";
};
export type UserProfilePreviewRelay_user$key = {
  readonly " $data"?: UserProfilePreviewRelay_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelay_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserProfilePreviewRelay_user",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "picture"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "email"
        },
        {
          "concreteType": "AtlassianAccountUserExtendedProfile",
          "kind": "LinkedField",
          "name": "extendedProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jobTitle"
            },
            {
              "kind": "ScalarField",
              "name": "department"
            },
            {
              "kind": "ScalarField",
              "name": "location"
            },
            {
              "kind": "ScalarField",
              "name": "organization"
            }
          ]
        }
      ],
      "type": "AtlassianAccountUser"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "70d23d9811371f679ef1c4d71029fbb2";

export default node;
